import React from 'react';

import { Col } from 'reaxl';
import { InventoryListingPlaceholder } from 'reaxl-listing';

export default function SupplementalSearchPlaceholder() {
    return Array(6).fill().map((_, index) => (
        <Col
            xs={12}
            sm={6}
            md={4}
            key={`supplemental-placeholder-${index}`}
        >
            <InventoryListingPlaceholder
                data-cmp="inv-placeholder-supplemental"
            />
        </Col>
    ));
}
